// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_FayG_h2RS5hc50b1l1{display:flex;justify-content:center;align-items:center;width:100%}`, "",{"version":3,"sources":["webpack://./src/app/catalog/product/components/input-search.component/style.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,UAAA","sourcesContent":[".searcn-input-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searcn-input-container": `G_FayG_h2RS5hc50b1l1`
};
export default ___CSS_LOADER_EXPORT___;
